module.exports = __webpack_public_path__ + "static/media/bottom_shape_7_mob.3c040639.svg";